module.exports = __webpack_public_path__ + "img/箭头1.a294e93d.svg";